/**
 * Global Random functions
 */
export default {

  /**
   * Returns a random number in a range
   * @param {*} min the min 
   * @param {*} max  the max
   */
  RandomNumber(min, max) {
    return Math.random() *(max-min) + min
  },
  /**
   * Returns a random int in the range
   * @param {*} min the min 
   * @param {*} max  the max
   */
  RandomInt(min,max) {
    return Math.floor(this.RandomNumber(min,max))
  },
  /**
   * returns true/false 50% of the time
   */
  CoinToss() {
    return Math.random() > 0.5
  }
}